
define('text!templates/modules/calendar/favorite/edit/favorite-edit-content.html',[],function () { return '<div class="panel-body favorite-edit-content">\n    <ul class="menu-actions nav nav-pills"></ul>\n\n    <div class="favorite-edit-form"></div>\n\n</div>\n';});

